// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var AuthenticatedComponentRelay = require("./AuthenticatedComponentRelay.bs.js");

function RequireAuthenticatedAgent(props) {
  var children = props.children;
  return JsxRuntime.jsx(AuthenticatedComponentRelay.make, {
              requiredUserRole: "agent",
              renderWrappedComponent: (function () {
                  return children;
                }),
              loaderComponent: props.loaderComponent
            });
}

var make = RequireAuthenticatedAgent;

exports.make = make;
/* react/jsx-runtime Not a pure module */
